import { getBackgroundCSS, getBorderCSS, getIconCSS } from '../../../Components/Helper/getCSS';

const Style = ({ attributes, clientId }) => {
	const { background, hoverBG, icon, iconWidth, iconBorder, titleColor, descColor, linkIconColor, linkBGColor, linkBGHovColor } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		#ssbService-${clientId} .ssbService{
			${getBackgroundCSS(background)}
		}
		#ssbService-${clientId} .ssbService .bgLayer{
			${getBackgroundCSS(hoverBG)}
		}

		#ssbService-${clientId} .ssbService .title{
			color: ${titleColor};
		}
		#ssbService-${clientId} .ssbService .icon{
			${getBorderCSS(iconBorder)}
		}
		#ssbService-${clientId} .ssbService .icon i{
			${getIconCSS(icon)}
		}
		#ssbService-${clientId} .ssbService .icon img{
			width: ${iconWidth};
		}
		#ssbService-${clientId} .ssbService .description{
			color: ${descColor};
		}
		#ssbService-${clientId} .ssbService .link a{
			background-color: ${linkBGColor};
		}
		#ssbService-${clientId}:hover .ssbService .link a{
			background-color: ${linkBGHovColor};
		}
		#ssbService-${clientId} .ssbService .link a svg{
			fill: ${linkIconColor};
		}
		`.replace(/\s+/g, ' ')
	}} />
}
export default Style;